angular.module('angus.directives').directive('paygoExceptions', [
    '$document', 'actionViewTemplates',
    function($document, actionViewTemplates) {
        'use strict';

        return {
            scope: {
                closeCb: '=',
                actionModel: '=',
                widgetClass: '=',
                windowId: '='
            },
            controller: function($scope) {


                $scope.close = function() {
                    if ($scope.modalClosedCb) $scope.modalClosedCb();
                    if ($scope.closeCb) $scope.closeCb();
                };

                $scope.$watch(function() {
                    return $scope.actionModel;
                }, function(newVal) {
                    if (newVal) {
                        $scope.activeDealerIds = newVal.activeDealerIds || null;
                        $scope.activeSubscriberId = newVal.activeSubscriberId || null;
                        $scope.exceptionGroups = newVal.exceptionGroups || null;
                    }
                }, true);
            },
            templateUrl: actionViewTemplates.paygoExceptionsActionView1,
            link: function(scope, element) {
                scope.modalClosedCb = function() {
                    $document.unbind('click');
                };

                element.bind('click', function(e) {
                    e.stopPropagation();
                });
            }
        };
    }
]);